import { defineComponent as _defineComponent } from 'vue'
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { ref, provide, onMounted } from 'vue';
import chartsApi from '@/api/charts';

type history = {
    date: string;
    num: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'line',
  setup(__props, { expose: __expose }) {

use([
    CanvasRenderer,
    LineChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);

provide(THEME_KEY, 'default');
const chart = ref();

let xArr = ref<string[]>([]);
let seriesArr = ref<number[]>([]);
const option = ref({
    title: {
        text: '您的访问频率',
        left: 'center',
    },
    xAxis: {
        type: 'category',
        data: xArr
    },
    yAxis: {
        type: 'value'
    },
    series: [
        {
            data: seriesArr,
            type: 'line'
        }
    ]
});

function resize() {
    chart.value.resize();
}

__expose({ resize });

onMounted(async () => {
    const res = await chartsApi.frequency(10);
    res.request.map((item: history) => {
        xArr.value.push(item.date.slice(-5));
        seriesArr.value.push(item.num);
    })
})

const __returned__ = { chart, get xArr() { return xArr }, set xArr(v) { xArr = v }, get seriesArr() { return seriesArr }, set seriesArr(v) { seriesArr = v }, option, resize, get VChart() { return VChart } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})